@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.item-list-read-only {
  padding: 15px;
  background: @item-list-read-only--order-item--background-color;
  border: 1px solid @item-list-read-only--order-item--border-color;
  border-radius: 4px;

  &.no-items {
    padding: 10px;
    border: 0;
    border-radius: 0;
    border-top: 1px solid @item-list-read-only--order-item-no-items--border-color;
    background: transparent;
  }
}

.no-items-placeholder {
  font-size: 13px;
  color: @item-list-read-only--order-item-no-items--text-color;
  text-align: center;
  font-style: italic;
}

.item {
  margin-bottom: 10px;

  &:last-child {
    margin: 0;
  }
}

.read-only-item {
  display: flex;
}

.item-display {
  width: 100%;
  align-self: flex-start;
}

.item-quantity {
  align-self: flex-start;
  margin-left: 10px;
  height: 80px;
}
